import { iconos } from "../../../assets";

export const items = [
  {
    id: 1,
    icon: iconos.chatbot.src,
    title: "Chatbots with RAG",
    resume: "Empower your business with intelligent conversational agents that provide accurate, context-aware responses by integrating directly with your proprietary knowledge bases. Our RAG-enhanced bots ensure every interaction is data-driven and highly relevant.",
    cuando: "Customer service, technical support, and complex inquiries.",
    beneficio: "Accurate, contextual answers based on your own data.",
  },
  {
    id: 2,
    icon: iconos.agents.src,
    title: "Autonomous AI Agents",
    resume: "Scale your operations with sophisticated AI agents capable of orchestrating complex workflows across SAP, CRM, and ERP systems. These agents perform independent decision-making and task execution, significantly reducing manual intervention and operational friction.",
    cuando: "Complex automation requiring interaction across multiple systems.",
    beneficio: "Operational efficiency and reduced human intervention.",
  },
  {
    id: 3,
    icon: iconos.vision.src,
    title: "Computer Vision",
    resume: "Unlock actionable insights from visual data using state-of-the-art image and video analysis. From industrial quality control to medical diagnostics, our computer vision models automate perception and verification with unparalleled precision and speed.",
    cuando: "Quality control, medical diagnostics, and document digitization.",
    beneficio: "High-precision visual automation.",
  },
  {
    id: 4,
    icon: iconos.automation.src,
    title: "Process Automation",
    resume: "Transform fragmented manual tasks into seamless end-to-end automated workflows. We provide the digital foundation for operational excellence, integrating disparate systems and implementing automated testing to ensure zero-error reliability.",
    cuando: "Repetitive processes and manual workflows.",
    beneficio: "Resource optimization and error reduction.",
  },
  {
    id: 5,
    icon: iconos.gen_ai.src,
    title: "Generative AI",
    resume: "Revolutionize content production and creative workflows using advanced large language models. Our generative AI solutions automate report writing, multilinguistic translations, and marketing asset creation at a scale that keeps you ahead of the market.",
    cuando: "Scale content creation and product localization.",
    beneficio: "Amplified creativity and global reach.",
  },
  {
    id: 6,
    icon: iconos.nlp.src,
    title: "NLP & Sentiment Analysis",
    resume: "Gain a competitive edge by deeply understanding the voice of your customer through advanced text mining. Our NLP engines classify global feedback, monitor brand sentiment in real-time, and extract strategic intelligence from massive volumes of unstructured data.",
    cuando: "Customer feedback analysis and brand monitoring.",
    beneficio: "Deep understanding of customer perception.",
  },
  {
    id: 7,
    icon: iconos.recommendation.src,
    title: "Recommendation Systems",
    resume: "Deliver hyper-personalized user experiences that drive engagement and long-term loyalty. Using sophisticated collaborative filtering and deep learning architectures, our recommendation engines predict user needs and maximize conversion opportunities.",
    cuando: "E-commerce, multimedia content, and personalized marketing.",
    beneficio: "Increased conversion and user loyalty.",
  },
  {
    id: 8,
    icon: iconos.documents.src,
    title: "Document Processing",
    resume: "Eliminate administrative bottlenecks by automating the extraction and classification of data from thousands of documents. Our intelligent document processing solutions handle billing, legal forms, and records with extreme accuracy and lightning speed.",
    cuando: "Document management, billing, and form processing.",
    beneficio: "Accelerated digitization and fast access to information.",
  },
];
